import React, { Component } from 'react';
import classNames from 'classnames/bind';
// // import $ from 'jquery';
import confetti from 'canvas-confetti';
import ahoy from 'ahoy.js';

import UsageLicenseTypeSelect from '~/components/legacy/UsageLicenseTypeSelect.jsx'
import { buildProjectLicenseCartRequestData, buildProjectLicenseCartRemoveRequestData, buildProjectLicenseTrackingProps } from '~/components/legacy/projectLicenseCartSelection.js'
import { trackCatalogEvent, withRankingPayload } from '~/modules/catalogEventTracking.js';
import { requestJson } from '~/modules/legacyRequest.js';
import legacyEventHub from '~/modules/legacyRuntime.js';
import TrackDetailsDrawer from '~/components/legacy/TrackDetailsDrawer.jsx'
import SimilarTracksDrawer from '~/components/legacy/SimilarTracksDrawer.jsx'
import ProjectAddTo from '~/components/legacy/ProjectAddTo.jsx'

const MIN_DEMO_DOWNLOAD_LENGTH_SECONDS = 15;

class StaticTrack extends Component {

  // mixins : [UsageLicenseTypeSelectMixin],

  constructor(props) {
    super(props)

    this.handleClick = this.handleClick.bind(this)
    this.handleLayoutDownloadClick = this.handleLayoutDownloadClick.bind(this)
    this.handleShareClick = this.handleShareClick.bind(this)
    this.handlefreeDownloadBuyInShopClick = this.handlefreeDownloadBuyInShopClick.bind(this)
    this.handlefreeDownloadAgreeClick = this.handlefreeDownloadAgreeClick.bind(this)
    this.handleNextClick = this.handleNextClick.bind(this)
    this.handlePrevClick = this.handlePrevClick.bind(this)
    this.handleFavoriteClick = this.handleFavoriteClick.bind(this)
    this.handleFreeDownloadClick = this.handleFreeDownloadClick.bind(this)
    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)
    this.handleVariantClick = this.handleVariantClick.bind(this)
    this.handleCartClick = this.handleCartClick.bind(this)
    this.openTrackDetailsDrawer = this.openTrackDetailsDrawer.bind(this)
    this.closeTrackDetailsDrawer = this.closeTrackDetailsDrawer.bind(this)
    this.openSimilarTracksDrawer = this.openSimilarTracksDrawer.bind(this)
    this.closeSimilarTracksDrawer = this.closeSimilarTracksDrawer.bind(this)
    this.handleUsageLicenseTypeSelectClose = this.handleUsageLicenseTypeSelectClose.bind(this)
    this.updateProjectLicenseFamily = this.updateProjectLicenseFamily.bind(this)
    this.removeProjectLicenseSelection = this.removeProjectLicenseSelection.bind(this)
    this.updateCart = this.updateCart.bind(this)
    this.handleProjectTrackRemove = this.handleProjectTrackRemove.bind(this)
    this.eventHubListeners = []

    this.state = {
      playing: false,
      isHovered: false,
      showUsageLicenseSelect: false,
      showTrackDetailsDrawer: false,
      showSimilarTracksDrawer: false,
      projectTrackRemoveBusy: false,
      projectTrackRemoveError: false
    }
  }

  componentDidMount() {
    let that = this;

    this.registerEventHubListener('updateTrackInfo', function (data) {
      if (data[0].id !== that.props.id) {
        that.setState({
          playing: false
        });
      }
    });

    this.registerEventHubListener('updateTrackVariantInfo', function (data) {
      if (data[0].id !== that.props.id) {
        that.setState({
          playing: false
        });
      }
    });


    this.registerEventHubListener('audioPlayerPlay', function (data) {
      if (data[0].id === that.props.id) {
        that.setState({
          playing: true
        });
      }
    });


    this.registerEventHubListener('audioPlayerStop', function () {
      if (that.state.playing) {
        that.setState({
          playing: false
        });
      }
    });

    this.registerEventHubListener('audioPlayerEnded', function () {
      if (that.state.playing) {
        that.setState({
          playing: false
        });
      }
    });
  }

  componentWillUnmount() {
    const eventHub = this.eventHub()

    if (!eventHub || typeof eventHub.off !== 'function') {
      this.eventHubListeners = []
      return
    }

    this.eventHubListeners.forEach(function(listener) {
      eventHub.off(listener.eventName, listener.handler)
    })
    this.eventHubListeners = []
  }

  registerEventHubListener(eventName, handler) {
    const eventHub = this.eventHub()
    if (!eventHub || typeof eventHub.on !== 'function') {
      return
    }

    eventHub.on(eventName, handler)
    this.eventHubListeners.push({ eventName: eventName, handler: handler })
  }

  eventHub() {
    return legacyEventHub
  }

  triggerEventHub(eventName, ...args) {
    const eventHub = this.eventHub()
    if (!eventHub || typeof eventHub.trigger !== 'function') {
      return
    }

    eventHub.trigger(eventName, ...args)
  }

  handleClick(e) {
    e.preventDefault();
    this.triggerEventHub('playTrack', this.props.id, this.props);
    this.triggerEventHub('updateTrackInfo', this.props);
    this.setState({
      playing: !this.state.playing
    });
  }

  handleLayoutDownloadClick(e) {
    if (!this.demoDownloadAllowed()) {
      return;
    }

    this.triggerDemoDownload();

    if (typeof confetti !== 'undefined') {
      let rect = e.target.getBoundingClientRect();
      console.log(rect.top, rect.right, rect.bottom, rect.left);

      confetti({
        particleCount: 200,
        startVelocity: 20,
        angle: 90,
        spread: 60,
        origin: {
          x: (rect.left + 10) / window.innerWidth,
          // since they fall down, start a bit higher than random
          y: (rect.top + 30) / window.innerHeight
        },
        colors: ['#e97900', '#d77812', '#ffd6aa', '#43ce00', '#63de00', '#a4d08f', '#52489C', '#635b9a', '#baafff']
      });
    }
  }

  handleShareClick(e) {
    e.preventDefault();

    if (this.state.displayCopyHint) {
      this.setState({ displayCopyHint: false });
    } else {
      if (!this.state.shareTrackingFired) {
        trackCatalogEvent('track_share', { track_id: this.props.id, location: window.location.href });
      }

      if (navigator.share) {
        // Web Share API is supported
        navigator.share({
          title: (this.props.display_title || this.props.title) + ' | ' + (this.props.locale === 'de' ? 'GEMAfreie Musik auf audiocrowd.net' : 'Royalty-free music on audiocrowd.net'),
          url: this.props.showcaseUrl + '?utm_source=share_link_teaser&utm_medium=referral'
        })
        this.setState({ shareTrackingFired: true });
      } else {
        // Fallback
        this.copyToClipboard(this.props.showcaseUrl + '?utm_source=share_link_teaser&utm_medium=referral');
        this.setState({ displayCopyHint: true, shareTrackingFired: true }, function () {
          setTimeout(function () {
            this.setState({ displayCopyHint: false })
          }.bind(this), 5000)
        });
      }

      if (typeof confetti !== 'undefined') {
        let rect = e.target.getBoundingClientRect();
        console.log(rect.top, rect.right, rect.bottom, rect.left);

        confetti({
          particleCount: 200,
          startVelocity: 30,
          angle: 90,
          spread: 60,
          shapes: ['circle'],
          origin: {
            x: (rect.left + 10) / window.innerWidth,
            // since they fall down, start a bit higher than random
            y: (rect.top + 20) / window.innerHeight
          },
          colors: ['#e97900', '#d77812', '#ffd6aa', '#43ce00', '#63de00', '#a4d08f', '#52489C', '#635b9a', '#baafff']
        });
      }
    }
  }

  copyToClipboard(str) {
    let el = document.createElement('textarea');

    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  }


  triggerDemoDownload() {
    if (!this.demoDownloadAllowed()) {
      return;
    }

    let returnTo = encodeURIComponent((window.location.pathname || '/') + (window.location.search || ''));
    let customerSignedIn = (document.body?.getAttribute('data-user-tracking-context') || '').indexOf('customer') === 0;
    let link = document.createElement("a"),
      uri = '/c/tracks/' + this.props.id + '/download_layout?return_to=' + returnTo,
      isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor),
      isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

    // If you don't know the name or want to use
    // the webserver default set name = ''

    link.href = uri

    trackCatalogEvent('track_layout_download_intent', { track_id: this.props.id, location: window.location.href });

    if (customerSignedIn) {
      // logged in
      if (!isChrome && !isFirefox) {
        link.setAttribute('download', '');
      }
    }

    if (customerSignedIn) {
      trackCatalogEvent('track_layout_download', { track_id: this.props.id, location: window.location.href });
    }

    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  demoDownloadAllowed() {
    return Number(this.props.length || 0) >= MIN_DEMO_DOWNLOAD_LENGTH_SECONDS;
  }

  handlefreeDownloadBuyInShopClick(e) {
    e.preventDefault();
    let win = window.open(this.props.showcaseUrl, '_blank');
    // let win = window.open((this.props.locale === 'de' ? ('http://localhost:3000/tracks/' + this.props.id + '/free_download') : ('http://localhost:3000/tracks/' + this.props.id + '/free_download')), '_blank');
    win.focus();

    console.log('handle buy in shop click');
  }

  handlefreeDownloadAgreeClick(e) {
    e.preventDefault();

    trackCatalogEvent('track_download_free', { track_id: this.props.id, location: window.location.href })

    let win = window.open((this.props.locale === 'de' ? ('/tracks/' + this.props.id + '/free_download') : ('/tracks/' + this.props.id + '/free_download')), '_blank');
    // let win = window.open((this.props.locale === 'de' ? ('http://localhost:3000/tracks/' + this.props.id + '/free_download') : ('http://localhost:3000/tracks/' + this.props.id + '/free_download')), '_blank');
    win.focus();
  }

  handlefreeDownloadRejectClick(e) {
    e.preventDefault();
    console.log('handle reject click');
  }

  handleNextClick(e) {
      e.preventDefault();
      this.triggerEventHub('playTrack', this.props.next_track.id, this.props.next_track);
      this.triggerEventHub('updateTrackInfo', this.props.next_track);
    this.setState({
      playing: !this.state.playing
    });
  }

  handlePrevClick(e) {
      e.preventDefault();
      this.triggerEventHub('playTrack', this.props.prev_track.id, this.props.prev_track);
      this.triggerEventHub('updateTrackInfo', this.props.prev_track);
    this.setState({
      playing: !this.state.playing
    });
  }

  handleFavoriteClick(e) {
    e.preventDefault();

    this.props.handleFavoriteClick(this.props.id);

    if (!this.props.favorited && typeof confetti !== 'undefined') {
      let rect = e.target.getBoundingClientRect();
      console.log(rect.top, rect.right, rect.bottom, rect.left);

      confetti({
        particleCount: 200,
        startVelocity: 30,
        angle: 90,
        spread: 60,
        shapes: ['circle'],
        origin: {
          x: (rect.left + 10) / window.innerWidth,
          // since they fall down, start a bit higher than random
          y: (rect.top + 20) / window.innerHeight
        },
        colors: ['#e97900', '#d77812', '#ffd6aa', '#43ce00', '#63de00', '#a4d08f', '#52489C', '#635b9a', '#baafff']
      });
    }
  }

  handleFreeDownloadClick(e) {
    e.preventDefault();
    this.props.handleFreeDownloadClick(this.props.id);
  }

  handleFreeDownloadDialogClick(e) {
    e.preventDefault();
  }

  handlefreeDownloadRejectClick(e) {
    e.preventDefault();
    this.triggerEventHub('closePopupMenus');
  }


  handleTagClick(tagId, e) {
    e.preventDefault();
    this.triggerEventHub('trackTagClick', tagId);
  }

  handleGenreClick(genreId, e) {
    e.preventDefault();
    this.triggerEventHub('trackGenreClick', genreId);
  }

  handleMoodClick(moodId, e) {
    e.preventDefault();
    this.triggerEventHub('trackMoodClick', moodId);
  }

  handleMouseEnter(e) {
    e.preventDefault();
    this.setState({
      isHovered: true
    });
  }

  handleMouseLeave(e) {
    e.preventDefault();
    this.setState({
      isHovered: false
    });
  }

  handleVariantClick(variantId, trackId, variantTitle, e) {
    e.preventDefault();
    this.triggerEventHub('playTrackVariant', variantId, trackId);
    this.setState({
      playing: false
    });
  }


  truncate(text, count) {
    return (text.length > count) ? text.substr(0, count - 1) + '...' : text;
  }


  updateCart(usageLicenseTypeId, exposurePackId, forFx) {
    let itemId = this.props.id || this.state.data.id,
      i,
      updateUrl;

    if (exposurePackId) {
      updateUrl = "/cart?exposure_pack_id=" + exposurePackId + "&usage_license_type_id=" + usageLicenseTypeId;
    } else if (forFx) {
      updateUrl = "/cart?sound_effect_id=" + itemId + "&usage_license_type_id=" + usageLicenseTypeId;
    } else {
      updateUrl = "/cart?track_id=" + itemId + "&usage_license_type_id=" + usageLicenseTypeId;
    }

    return requestJson(updateUrl, {
      method: 'POST',
      data: this.cartRequestContext()
    }).then(function (data) {

      this.triggerEventHub('updateCart', data)

      var cartItems = data.items || data;

      // One click should emit one add_cart event, even if cartItems has duplicates.
      for (i = 0; i < cartItems.length; i += 1) {
        if (cartItems[i].track_id === itemId) {
          trackCatalogEvent('track_add_cart', { track_id: itemId, usage_license_type_id: usageLicenseTypeId, location: window.location.href });
          break;
        } else if (cartItems[i].sound_effect_id === itemId) {
          trackCatalogEvent('sound_effect_add_cart', { sound_effect_id: itemId, usage_license_type_id: usageLicenseTypeId, location: window.location.href });
          break;
        }
      }

      if (typeof fbq === 'function') {
        fbq('track', 'AddToWishlist', {
          content_ids: itemId.toString(),
          content_type: 'product',
        });
      }

    }.bind(this));
  }

  updateProjectLicenseFamily(projectLicenseSelection) {
    let itemId = this.props.id || this.state.data.id;
    const requestData = buildProjectLicenseCartRequestData(itemId, projectLicenseSelection, this.cartRequestContext());
    const trackingProps = buildProjectLicenseTrackingProps(itemId, projectLicenseSelection, window.location.href);

    if (!requestData) {
      return null;
    }

    return requestJson('/cart', {
      method: 'POST',
      data: requestData
    }).then(function (data) {
      this.triggerEventHub('updateCart', data)

      trackCatalogEvent('track_add_cart', trackingProps)
    }.bind(this));
  }

  removeProjectLicenseSelection(projectLicenseSelection) {
    let itemId = this.props.id || this.state.data.id;
    const requestData = buildProjectLicenseCartRemoveRequestData(itemId, projectLicenseSelection);

    if (!requestData) {
      return null;
    }

    return requestJson('/cart', {
      method: 'POST',
      data: requestData
    }).then(function (data) {
      this.triggerEventHub('updateCart', data)
    }.bind(this));
  }

  handleCartClick(e) {
    e.preventDefault();
    this.props.handleCartClick(this.props.id);
  }

  handleProjectTrackRemove(e) {
    e.preventDefault();

    if (this.state.projectTrackRemoveBusy || !this.props.projectTrackRemovePath) {
      return;
    }

    this.setState({ projectTrackRemoveBusy: true, projectTrackRemoveError: false });
    requestJson(this.props.projectTrackRemovePath, { method: 'DELETE' })
      .then((data) => {
        this.setState({ projectTrackRemoveBusy: false });
        this.props.onProjectTrackRemoved?.(this.props.id, data && data.project_track_count);
      })
      .catch(() => {
        this.setState({ projectTrackRemoveBusy: false, projectTrackRemoveError: true });
      });
  }

  openTrackDetailsDrawer(e) {
    e.preventDefault();

    this.setState({ showTrackDetailsDrawer: true });
  }

  closeTrackDetailsDrawer(e) {
    if (e) {
      e.preventDefault();
    }

    this.setState({ showTrackDetailsDrawer: false });
  }

  openSimilarTracksDrawer(e) {
    e.preventDefault();

    trackCatalogEvent('track_show_similar_tracks', { track_id: this.props.id, location: window.location.href });

    this.setState({ showSimilarTracksDrawer: true });
  }

  closeSimilarTracksDrawer(e) {
    if (e) {
      e.preventDefault();
    }

    this.setState({ showSimilarTracksDrawer: false });
  }

  handleUsageLicenseTypeSelectClose(e) {
    e.preventDefault();

    if (typeof this.props.handleUsageLicenseTypeSelectClose === 'function') {
      this.props.handleUsageLicenseTypeSelectClose(this.props.id);
      return;
    }

    this.props.handleCartClick(this.props.id);
  }

  getSelectedUsageLicenseTypeIds() {
    let ids = [],
      that = this,
      trackId = this.props.id || that.state.data.id,
      cart_items = this.state.cart_items || this.props.cart_items;

    cart_items.forEach(function (element) {
      if (element.track_id === trackId) {
        ids.push(element.usage_license_type_id);
      }
    });

    return ids;
  }

  getSelectedProjectLicenseFamilyKeys() {
    let familyKeys = [],
      that = this,
      trackId = this.props.id || that.state.data.id,
      cart_items = this.state.cart_items || this.props.cart_items;

    cart_items.forEach(function (element) {
      if (element.track_id === trackId && element.project_license_family_key) {
        familyKeys.push(element.project_license_family_key);
      }
    });

    return familyKeys;
  }

  getSelectedProjectLicenseSelections() {
    let selections = [],
      that = this,
      trackId = this.props.id || that.state.data.id,
      cart_items = this.state.cart_items || this.props.cart_items;

    cart_items.forEach(function (element) {
      if (element.track_id === trackId && element.project_license_family_key) {
        selections.push({
          familyKey: element.project_license_family_key,
          usageLicenseTypeId: element.usage_license_type_id,
          selectedOptionKeys: element.project_license_option_keys,
          customerProjectLicensePresetId: element.customer_project_license_preset_id,
          customerEventLicensePresetId: element.customer_event_license_preset_id,
          projectLicensePresetName: element.project_license_preset_name
        });
      }
    });

    return selections;
  }

  cartRequestContext() {
    return withRankingPayload({ location: window.location.href }, this.state.data || this.props.data || this.props);
  }



  render() {
    let classes = classNames({
      'static-track': true,
      'static-track--slim': this.props.slim,
      'static-track--active': this.props.active,
      'static-track--new': this.props.recently_activated,
      'static-track--favorited': this.props.favorited,
      'static-track--license-select-open': this.props.showUsageLicenseSelect,
      'static-track--playing': this.state.playing && !(parseInt(this.props.activeTrackVariantId, 10) > 0),
      'static-track--variant-playing': this.state.playing && (parseInt(this.props.activeTrackVariantId, 10) > 0)
    }),
      cartLink,
      favoriteLink,
      projectAction,
      recentlyCreatedLabel,
      cartLinkIcon,
      usageLicenseTypeSelect;

    let layoutDownloadLink,
      shareLink,
      freeDownloadDialog,
      copyHint,
      projectTrackRemoveAction;

    if (this.state.displayCopyHint && !navigator.share) {
      copyHint = <div className="static-track__copy-hint">
        <div className="static-track__copy-hint-content">
          <i className='static-track__copy-hint-icon fa fa-check'></i>
          <span className='static-track__copy-hint-text'>{this.props.locale === 'de' ? 'Die Track-URL wurde in die Zwischenablage kopiert.' : 'The track URL was copied to your clipboard.'}</span>
        </div>
      </div>;
    }


    if (this.demoDownloadAllowed()) {
      layoutDownloadLink = <a className="static-track__layout-download" onClick={this.handleLayoutDownloadClick} title="Layout-Download">
        <i className='fa fa-download'></i>
        <span className='static-track__download-link-label'>Demo</span>
        {/* <i className="fa fa-download"></i><span className="static-track__layout-download-label">{this.props.layout_download}</span> */}
      </a>;
    } else {
      layoutDownloadLink = <span className="static-track__layout-download static-track__layout-download--disabled" title="Layout-Download deaktiviert" aria-disabled="true">
        <i className='fa fa-download'></i>
        <span className='static-track__download-link-label'>Demo</span>
      </span>;
    }

    if (!this.props.hideShareAction) {
      shareLink = (
        <button type='button' className="static-track__share" onClick={this.handleShareClick} title={this.props.locale === 'de' ? 'Track teilen' : 'Share this track'} aria-label={this.props.locale === 'de' ? 'Track teilen' : 'Share this track'}>
          <i className='fa fa-share-alt'></i>
          <span className='static-track__share-link-label'>{this.props.locale === 'de' ? 'Teilen' : 'share'}</span>
          {/* <i className="fa fa-download"></i><span className="static-track__layout-download-label">{this.props.layout_download}</span> */}
        </button>);
    }

    const favoriteLabel = this.props.favorited ?
      (this.props.locale === 'de' ? 'Aus Merkliste entfernen' : 'Remove from favorites') :
      (this.props.locale === 'de' ? 'Zur Merkliste hinzufügen' : 'Add to favorites');

    if (!this.props.hideFavoriteAction) {
      if (this.props.favorited) {
        favoriteLink = <a href='#' onClick={this.handleFavoriteClick} className='static-track__favorite-link' aria-label={favoriteLabel} title={favoriteLabel}><i className="fa fa-heart"></i><span className='static-track__favorite-label'>{this.props.locale === 'de' ? 'gemerkt' : 'remembered'}</span></a>;
      } else {
        favoriteLink = <a href='#' onClick={this.handleFavoriteClick} className='static-track__favorite-link' aria-label={favoriteLabel} title={favoriteLabel}><i className="fa fa-heart-o"></i><span className='static-track__favorite-label'>{this.props.locale === 'de' ? 'merken' : 'remember'}</span></a>;
      }
    }

    if (!this.props.freeMode) {
      const cartLinkLabel = this.props.show_download_button ?
        'Download' :
        (this.props.locale === 'de' ? 'Lizenz' : 'License');
      const cartActionLabel = this.props.inCart ?
        (this.props.remove_from_cart || cartLinkLabel) :
        (this.props.add_to_cart || cartLinkLabel);
      const cartLinkLabelClass = this.props.inCart && !this.props.show_download_button ?
        'static-track__cart-link-label hide-element' :
        'static-track__cart-link-label';

      if (this.props.inCart) {
        if (this.props.show_download_button) {
          cartLinkIcon = <span className='static-track__cart-link-icon'><i className="fa fa-download"></i></span>;
        } else {
          cartLinkIcon = <span className='static-track__cart-link-icon static-track__cart-link-icon--in-cart'><i className="static-track__cart-link-icon-added fa fa-check"></i><i className="fa fa-shopping-cart static-track__cart-link-icon-cart"></i></span>;
        }
        cartLink = this.props.show_download_button ?
          <a className="static-track__action-button-added-to-cart" href="#" onClick={this.handleCartClick} aria-label={cartActionLabel} title={cartActionLabel}>{cartLinkIcon}{this.props.remove_from_cart}</a> :
          <a className="static-track__action-button-added-to-cart" href="#" onClick={this.handleCartClick} aria-label={cartActionLabel} title={cartActionLabel}>
            {cartLinkIcon}
            <span className={cartLinkLabelClass}>{cartLinkLabel}</span>
            <span className='hide-element'>{this.props.remove_from_cart}</span>
          </a>
      } else {
        if (this.props.show_download_button) {
          cartLinkIcon = <span className='static-track__cart-link-icon'><i className="fa fa-download"></i></span>;
        } else {
          cartLinkIcon = <span className='static-track__cart-link-icon'><i className="static-track__cart-link-icon-add fa fa-plus"></i><i className="fa fa-shopping-cart static-track__cart-link-icon-cart"></i></span>;
        }
        cartLink = this.props.show_download_button ?
          <a className="static-track__action-button-add-to-cart" href="#" onClick={this.handleCartClick} aria-label={cartActionLabel} title={cartActionLabel}>{cartLinkIcon}{this.props.add_to_cart}</a> :
          <a className="static-track__action-button-add-to-cart" href="#" onClick={this.handleCartClick} aria-label={cartActionLabel} title={cartActionLabel}>
            {cartLinkIcon}
            <span className='static-track__cart-link-label'>{cartLinkLabel}</span>
            <span className='hide-element'>{this.props.add_to_cart}</span>
          </a>
      }
    }

    if (this.props.showUsageLicenseSelect && !this.props.freeMode) {
      usageLicenseTypeSelect = (
        <UsageLicenseTypeSelect
          locale={this.props.locale}
          addToCart={this.props.i18n.add_to_cart}
          discount={this.props.discount}
          usageLicenseTypes={this.props.usageLicenseTypes}
          subscribedUsageLicenseTypes={this.props.subscribedUsageLicenseTypes}
          updateCart={this.updateCart}
          pricing_path={this.props.pricing_path}
          licenseNavigatorPath={this.props.licenseNavigatorPath}
          allowedProjectLicenseFamilyKeys={this.props.allowedProjectLicenseFamilyKeys}
          selectionMode='project_license_family'
          updateProjectLicenseFamily={this.updateProjectLicenseFamily}
          removeProjectLicenseSelection={this.removeProjectLicenseSelection}
          selectedUsageLicenseTypeIds={this.getSelectedUsageLicenseTypeIds()}
          selectedProjectLicenseFamilyKeys={this.getSelectedProjectLicenseFamilyKeys()}
          selectedProjectLicenseSelections={this.getSelectedProjectLicenseSelections()}
          cartItems={this.state.cart_items || this.props.cart_items}
          i18n={this.props.i18n}
          visible={this.props.showUsageLicenseSelect}
          position='overlay'
          show_download_button={this.props.show_download_button}
          handleCartClick={this.handleCartClick}
          onRequestClose={this.handleUsageLicenseTypeSelectClose}
          trackTitle={this.props.display_title || this.props.title}
          trackArtist={this.props.composerName}
          trackImageMarkup={this.props.track_image_markup} />
      );
    }

    if (this.props.projectTrackRemoveEnabled && this.props.projectTrackRemovePath) {
      const removeLabel = this.props.locale === 'de' ? 'Aus Projekt entfernen' : 'Remove from project';
      projectTrackRemoveAction = (
        <>
          <button type='button' className='static-track__project-remove' onClick={this.handleProjectTrackRemove} disabled={this.state.projectTrackRemoveBusy} aria-label={removeLabel} title={removeLabel}>
            <i className={this.state.projectTrackRemoveBusy ? 'fa fa-spinner fa-spin' : 'fa fa-trash-o'} aria-hidden='true'></i>
            <span className='static-track__project-remove-label'>{this.props.projectTrackRemoveFullLabel ? removeLabel : (this.props.locale === 'de' ? 'Entfernen' : 'Remove')}</span>
          </button>
          {this.state.projectTrackRemoveError ? <span className='static-track__project-remove-error' role='alert'>{this.props.locale === 'de' ? 'Entfernen fehlgeschlagen.' : 'Could not remove.'}</span> : null}
        </>
      );
    }

    let trackDetailsDrawer = (
      <TrackDetailsDrawer
        visible={this.state.showTrackDetailsDrawer}
        locale={this.props.locale}
        trackId={this.props.id}
        trackTitle={this.props.display_title || this.props.title}
        projectActionEnabled={this.props.projectActionEnabled}
        trackArtist={this.props.composerName}
        length={this.props.length}
        playing={this.state.playing}
        favorited={this.props.favorited}
        inCart={this.props.inCart}
        freeMode={this.props.freeMode}
        showDownloadButton={this.props.show_download_button}
        activeTrackVariantId={this.props.activeTrackVariantId}
        trackImageMarkup={this.props.track_image_markup}
        royaltyFree={this.props.royaltyFree}
        proShortName={this.props.pro_short_name}
        youtubeContentIdEnabled={this.props.youtube_content_id_enabled}
        showcaseUrl={this.props.showcaseUrl}
        trackVariants={this.props.track_variants}
        includedMediaBundles={this.props.included_media_bundles}
        onPlayToggle={this.handleClick}
        onFavoriteToggle={this.handleFavoriteClick}
        onShare={this.handleShareClick}
        onDemo={this.props.freeMode ? this.handleFreeDownloadClick : this.handleLayoutDownloadClick}
        onCart={this.handleCartClick}
        onRequestClose={this.closeTrackDetailsDrawer}
        onVariantSelect={(variant, event) => this.handleVariantClick(variant.id, variant.track_id, variant.title, event)} />
    );

    let similarTracksDrawer = (
      <SimilarTracksDrawer
        visible={this.state.showSimilarTracksDrawer}
        locale={this.props.locale}
        trackTitle={this.props.display_title || this.props.title}
        trackArtist={this.props.composerName}
        length={this.props.length}
        trackImageMarkup={this.props.track_image_markup}
        similarTracksUrl={this.props.similar_tracks_url || ('/api/tracks/' + this.props.id + '/similar?limit=10')}
        cartItems={this.props.cart_items}
        trackFavorites={this.props.trackFavorites}
        usageLicenseTypes={this.props.usageLicenseTypes}
        subscribedUsageLicenseTypes={this.props.subscribedUsageLicenseTypes}
        licenseNavigatorPath={this.props.licenseNavigatorPath}
        i18n={this.props.i18n}
        onRequestClose={this.closeSimilarTracksDrawer} />
    );

    projectAction = (
      <ProjectAddTo
        trackId={this.props.id}
        trackTitle={this.props.display_title || this.props.title}
        trackVariants={this.props.track_variants}
        locale={this.props.locale}
        enabled={this.props.projectActionEnabled}
      />
    );


    return (
      <div className={classes} id={'track-static-' + this.props.id} onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave} itemScope itemType='https://schema.org/CreativeWork'>
        <span itemProp="copyrightHolder" itemType="https://schema.org/Organization" itemScope="" className="hide-element"><span itemProp="name">audiocrowd GmbH</span></span>
        <span itemProp="publisher" itemType="https://schema.org/Organization" itemScope="" className="hide-element"><span itemProp="name">audiocrowd GmbH</span></span>
        <span itemProp="provider" itemType="https://schema.org/Organization" itemScope="" className="hide-element"><span itemProp="name">audiocrowd GmbH</span></span>
        <meta itemProp="isFamilyFriendly" content="true" />
        <meta itemProp="copyrightYear" content={this.props.copyrightYear}></meta>

        <div className='static-track__row'>
          <button type='button' className='static-track__play-button' onClick={this.handleClick} aria-label={this.state.playing ? (this.props.locale === 'de' ? 'Track pausieren' : 'Pause track') : (this.props.locale === 'de' ? 'Track abspielen' : 'Play track')}>
            <i className={(this.state.playing && !(parseInt(this.props.activeTrackVariantId, 10) > 0)) ? 'fa fa-pause' : 'fa fa-play'} />
          </button>
          <button type='button' className='static-track__headline' onClick={this.handleClick}>
            {this.props.hideTrackId ? null : <span className='static-track__id'>#{this.props.id}</span>}
            <span itemProp="name" className='static-track__title-value'>{this.props.display_title || this.props.title}</span>
          </button>
          <div className='static-track__actions'>
            {favoriteLink}
            {projectAction}
            {projectTrackRemoveAction}
            {shareLink}
            {cartLink}
            {!this.props.hideMoreAction ? <button type='button' className='static-track__more-details' onClick={this.openTrackDetailsDrawer} aria-label={this.props.locale === 'de' ? 'Weitere Aktionen öffnen' : 'Open more actions'}>
              <i className='fa fa-ellipsis-v'></i>
              <span className='static-track__more-details-label'>{this.props.locale === 'de' ? 'Mehr' : 'More'}</span>
            </button> : null}
          </div>
        </div>

        {usageLicenseTypeSelect}
        {trackDetailsDrawer}
        {similarTracksDrawer}
      </div>
    )
  }
};

StaticTrack.defaultProps = {
  cart_items: [],
  locale: 'de',
  hideComposerName: false,
  showProTrackBadge: true
}

export default StaticTrack;
